"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Z_IDX_INLINE_CHAT_MODALS = exports.Z_IDX_INLINE_CHAT_WINDOW = exports.STORYBOOK_BG = exports.UNREAD_NOTIFICATION_COLOR = exports.ERROR_DISCONNECTED_COLOR = exports.ERROR_BG_TEXT_COLOR = exports.ERROR_FONT_WEIGHT = exports.ERROR_FONT_SIZE = exports.ERROR_ACCENT = exports.ERROR_COLOR = exports.SYSTEM_DISABLED = exports.SYSTEM_MESSAGE_COLOR = exports.UNREAD_MESSAGE_BORDER_RADIUS = exports.SCROLL_TO_BOTTOM_COLOR = exports.SCROLL_TO_BOTTOM_BG = exports.RESPONSE_BUTTON_RECOMMENDED_COLOR = exports.RESPONSE_BUTTON_DEFAULT_COLOR = exports.MESSAGE_BUBBLE_NOT_MINE_COLOR = exports.MESSAGE_BUBBLE_NOT_MINE_BG = exports.MESSAGE_BUBBLE_MINE_COLOR = exports.MESSAGE_BUBBLE_MINE_BG = exports.MESSAGES_CONTAINER_BG = exports.HEADER_BG = exports.GLOBAL_HYPERLINK_INVERSE = exports.GLOBAL_HYPERLINK = exports.GLOBAL_COLOR = exports.GLOBAL_LINE_HEIGHT = exports.GLOBAL_FONT_SIZE = exports.MESSAGE_THIN_MARGIN = exports.MESSAGE_MARGIN = exports.MESSAGE_PADDING = exports.MESSAGE_MAX_WIDTH = exports.BOX_SHADOW = exports.BORDER_RADIUS = exports.BASE_TRANSITION = void 0;
const layout_1 = require("@nib/layout");
const theme_1 = require("@nib-components/theme");
// ------------------------------------
// Animation
exports.BASE_TRANSITION = 200;
// ------------------------------------
// Visual consistency
exports.BORDER_RADIUS = theme_1.borderRadiusStandard;
exports.BOX_SHADOW = "0px 0px 8px 3px rgba(0, 0, 0, 0.25)";
// ------------------------------------
// Message sizing and spacing
exports.MESSAGE_MAX_WIDTH = "300px";
exports.MESSAGE_PADDING = (0, layout_1.p)(2);
exports.MESSAGE_MARGIN = (0, layout_1.mt)(3);
// Thinner margins between messages from the same author
exports.MESSAGE_THIN_MARGIN = "1px";
// ------------------------------------
// Typography
exports.GLOBAL_FONT_SIZE = "14px";
exports.GLOBAL_LINE_HEIGHT = "20px";
// ------------------------------------
// Colors
// Globals
exports.GLOBAL_COLOR = theme_1.colorDarkest;
exports.GLOBAL_HYPERLINK = theme_1.colorBrandDark;
exports.GLOBAL_HYPERLINK_INVERSE = theme_1.colorWhite;
// Layout backgrounds
exports.HEADER_BG = theme_1.colorWhite;
exports.MESSAGES_CONTAINER_BG = theme_1.colorLightest;
// "Mine" messages
exports.MESSAGE_BUBBLE_MINE_BG = theme_1.colorBrandBase;
exports.MESSAGE_BUBBLE_MINE_COLOR = theme_1.colorWhite;
// "Not mine" messages
exports.MESSAGE_BUBBLE_NOT_MINE_BG = theme_1.colorWhite;
exports.MESSAGE_BUBBLE_NOT_MINE_COLOR = theme_1.colorDarkest;
// Response buttons
exports.RESPONSE_BUTTON_DEFAULT_COLOR = theme_1.colorDarkest;
exports.RESPONSE_BUTTON_RECOMMENDED_COLOR = theme_1.colorWhite;
// Scroll to bottom
exports.SCROLL_TO_BOTTOM_BG = theme_1.colorWhite;
exports.SCROLL_TO_BOTTOM_COLOR = theme_1.colorBrandBase;
exports.UNREAD_MESSAGE_BORDER_RADIUS = exports.BORDER_RADIUS;
// Transfer to agent system UI
exports.SYSTEM_MESSAGE_COLOR = theme_1.colorBrandDark;
// Disabled/faded
exports.SYSTEM_DISABLED = theme_1.colorLight;
// Warnings & Errors
// `color.${name}` are per the MDS page `color`: https://www.meshdesignsystem.com/components/colors/
exports.ERROR_COLOR = theme_1.colorError;
exports.ERROR_ACCENT = theme_1.colorBlack;
exports.ERROR_FONT_SIZE = exports.GLOBAL_FONT_SIZE;
exports.ERROR_FONT_WEIGHT = 400;
exports.ERROR_BG_TEXT_COLOR = "#FFF";
exports.ERROR_DISCONNECTED_COLOR = theme_1.colorDarkest;
// For the unread messages count badge/circle used in
// the `<ChatLauncher/>` Toolbar
exports.UNREAD_NOTIFICATION_COLOR = "crimson";
// ------------------------------------
// Storybook
// This colour was picked from Storybook's own website, and their code block background colour
exports.STORYBOOK_BG = "#f5f8fc";
// ------------------------------------
// Z-index
exports.Z_IDX_INLINE_CHAT_WINDOW = 99999;
exports.Z_IDX_INLINE_CHAT_MODALS = 100000; // i.e. +1